export default __webpack_public_path__ + "static/media/network.a9aaf42a.gif";